import { render, staticRenderFns } from "./BuildPooledStartups.vue?vue&type=template&id=988ff3a2&scoped=true"
import script from "./BuildPooledStartups.vue?vue&type=script&lang=js"
export * from "./BuildPooledStartups.vue?vue&type=script&lang=js"
import style0 from "./BuildPooledStartups.vue?vue&type=style&index=0&id=988ff3a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988ff3a2",
  null
  
)

export default component.exports